import { Component, OnInit } from '@angular/core';
import { Background } from '../../shared/components/background/background';
import { Router } from '@angular/router';
import { Button } from '../../shared/components/button/button';
import { AnalyticsService } from '../../shared/services/analytics.service';
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-thank-you',
  imports: [Background, Button],
  templateUrl: './thank-you.html',
  styleUrl: './thank-you.scss'
})
export class ThankYou implements OnInit {
  constructor(
    private router: Router,
    private analyticsService: AnalyticsService,
    private seo: SeoService,
  ) { }

  ngOnInit() {
    this.seo.apply({
      title: 'Thanks for Booking',
      description: 'Your call is on the calendar. We will reach out shortly to confirm details and next steps.',
      canonical: '/thank-you-for-booking/',
      type: 'website',
      noindex: true,
    });
  }

  ngAfterViewInit(){
    // this.analyticsService.trackEvent('booked_Call','','')

    // OpenAI/ChatGPT Ads conversion. Calendly's post-booking redirect lands here
    // top-level for every device (CalendlyService navigates full-page, not a popup),
    // marking a completed booking.
    this.analyticsService.trackBookingConversion();
  }

  navigateTo(path: string) {
    if (path === 'case-studies') {
      this.router.navigate(['/'], { fragment: 'case-studies' });
      return;
    }
    if (path === 'blog') {
      window.location.href = '/blog/'
    }

    this.router.navigate([path]);
  }
}
